const setFullDate = (date: string, newHour: string): string => {
  let fullDate: Date = new Date(date);

  fullDate = new Date(fullDate.setHours(+newHour.split(':')[0], +newHour.split(':')[1]));

  return fullDate.toJSON();
};

export default setFullDate;
